/*       */

import { gql } from '@apollo/client';

export default gql`
    mutation exportEntitiesSharingMutation(
        $name: String
        $description: String
        $type: String!
        $sharedWith: [ShareType!]!
        $filterBy: [JSON]
        $excludeBy: [JSON]
        $orderBy: [JSON]
        $startIndex: Int
        $stopIndex: Int
    ) {
        result: exportEntitiesSharing(
            name: $name
            description: $description
            type: $type
            sharedWith: $sharedWith
            filterBy: $filterBy
            excludeBy: $excludeBy
            orderBy: $orderBy
            startIndex: $startIndex
            stopIndex: $stopIndex
        ) {
            id
            type
            name
        }
    }
`;
